import React, { memo } from 'react';
import { styles } from './MarketplaceSellerInfoContent.css';
import { MarkdownBlock } from '@jbhi-fi/components/src/MarkdownBlock';

type MarketplaceSellerInfoContentProps = {
  shippingInfoMdx?: string;
  returnsRefundsPolicyMdx?: string;
};

export const MarketplaceSellerInfoContent = memo(
  ({ shippingInfoMdx, returnsRefundsPolicyMdx }: MarketplaceSellerInfoContentProps) => {
    return (
      <div className={styles.container} data-testid="marketplace-seller_accordion-content">
        {shippingInfoMdx ? (
          <div>
            <MarkdownBlock>{shippingInfoMdx}</MarkdownBlock>
          </div>
        ) : null}
        {returnsRefundsPolicyMdx ? (
          <div>
            <MarkdownBlock>{returnsRefundsPolicyMdx}</MarkdownBlock>
          </div>
        ) : null}
      </div>
    );
  }
);
